import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const SportsActivitiesData = () => {
  useEffect(() => {
    document.title = "Sports -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Facilities</li>

        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Sports </h1>
            </div>
          </div>
          <div className="row achievementli archivedata">
            <div className="col-lg-12">
              <h6>2023 - 2024</h6>
              <p>
                <b>Achievement</b>
              </p>
              <p>
                <b>Senior Wing</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1741477488.pdf"
                    target="_blank"
                  >
                    Delhi State Junior Basketball Championship 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1966270838.pdf"
                    target="_blank"
                  >
                    Taekwondo District level Championship 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0814108469.pdf"
                    target="_blank"
                  >
                    Abhigyan Ojha - Sub Junior Basketball Tournament
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1270786102.pdf"
                    target="_blank"
                  >
                    Inter-school Skating Championship
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0725051524.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Boys Basketball Championship 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1413613440.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Girls Basketball Championship 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0448722825.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior and Senior Girls Tennis Championship
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0298972667.pdf"
                    target="_blank"
                  >
                    Zonal Volleyball Championship (Boys) 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1406690620.pdf"
                    target="_blank"
                  >
                    Zonal Football Championship 2023-24: Sub Junior & Junior Boys
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0015553035.pdf"
                    target="_blank"
                  >
                    12th All India Air Force Inter Command Sports & Athletic Meet
                    2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0704114951.pdf"
                    target="_blank"
                  >
                    Sub Junior Boys National Football Championship
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0390264656.pdf"
                    target="_blank"
                  >
                    Delhi State School Games (Football)
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1430198463.pdf"
                    target="_blank"
                  >
                    CBSE Central Zone (Delhi Region) Tennis Championship 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1116348168.pdf"
                    target="_blank"
                  >
                    CBSE Central Zone Taekwondo Championship 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1573025801.pdf"
                    target="_blank"
                  >
                    Delhi State School Games (Basketball) 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0652747715.pdf"
                    target="_blank"
                  >
                    Delhi State School Games (Football) 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1715853139.pdf"
                    target="_blank"
                  >
                    Triental Cup (Football) 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1566102981.pdf"
                    target="_blank"
                  >
                    4th Fr. Thomas Thoomkuzhy Memorial Basketball Tournament 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0294453004.pdf"
                    target="_blank"
                  >
                    27th Fr. Peter Mermier Memorial Football Tournament 2023
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1589442711.pdf"
                    target="_blank"
                  >
                    67th National School Games Basketball Championship (Sub Junior)
                  </Link>
                </li>
              </ul>
              <p>
                <b>Junior Wing </b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1439692553.pdf"
                    target="_blank"
                  >
                    {" "}
                    Zonal Mini Boys Basketball
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0355314330.pdf"
                    target="_blank"
                  >
                    {" "}
                    Zonal Mini Lawn Tennis Girls 2023
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-2001675928.pdf"
                    target="_blank"
                  >
                    {" "}
                    Zonal Mini Volleyball Tournament Girls 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1268669596.pdf"
                    target="_blank"
                  >
                    {" "}
                    Zonal Mini Athletic Event Girls 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0535663264.pdf"
                    target="_blank"
                  >
                    {" "}
                    Zonal Mini Athletic Event- Boys
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0924556751.pdf"
                    target="_blank"
                  >
                    {" "}
                    Speed Skating Event (RSFI), Roller Skating Federation of India
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1606027734.pdf"
                    target="_blank"
                  >
                    {" "}
                    Zonal Mini Badminton Tournament Girls 2023
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0334377757.pdf"
                    target="_blank"
                  >
                    {" "}
                    CBSE Centre Zone (Delhi Region) Skating Tournament 2023
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1980739355.pdf"
                    target="_blank"
                  >
                    {" "}
                    CBSE National Roller Skating Championship 2023-24
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-1128245415.pdf"
                    target="_blank"
                  >
                    {" "}
                    61st National Roller Skating Championship 2023
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0088479721.pdf"
                    target="_blank"
                  >
                    {" "}
                    Skating Competition, K R Mangalam World School, Gurugram
                  </Link>
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-0689672201.pdf"
                    target="_blank"
                  >
                    {" "}
                    1 1th TAFS MINI FOOTBALL TOURNAMENT (BOYS) & 6th TAFS MINI
                    BASKETBALL TOURNAMENT (BOYS & GIRLS)
                  </Link>{" "}
                </li>
              </ul>
              <p>
                <b>Activities Conducted In The School</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/wcp-2305080853-0830209389-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    Inter Section Kho-Kho Tournament (Girls): Class VII
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/wcp-2305080853-1022000806-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    Inter Section Chess Competition (Girls)
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=/9Asq3uo4a391M5evCy5vKYi819rriWSK0vySBJ3pTM=">
                    {" "}
                    Inter section Kho-Kho Tournament (Boys): Class VII &amp; VIII
                  </Link>
                </li>
                <li>
                  <p>
                    <Link to="https://www.tafssp.com/events?enc=X28v+rmo26zvxu1duDix5UWp0KlLIOs2OUfbO4aZWso=">
                      {" "}
                      Inter Section Soccer (Boys) : Class X
                    </Link>{" "}
                  </p>
                </li>
                <li>
                  <p>
                    <Link
                      to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231210-0704114951.pdf"
                      target="_blank"
                    >
                      {" "}
                      Sub Junior Boys National Football Championship
                    </Link>
                  </p>
                </li>
                <li>
                  <p>
                    <Link to="https://www.tafssp.com/events.news?id=1828&amp;eventname=annual-athletic-meet-2023-24">
                      {" "}
                      Annual Athletic Meet 2023-24
                    </Link>
                  </p>
                </li>
              </ul>
              <h6>2022-2023</h6>
              <p>
                <b>Achievement</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_73.pdf?Qlq6x"
                    target="_blank"
                  >
                    7th Grand Open National Taekwondo Championship 2022{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_74.pdf?Jo0up"
                    target="_blank"
                  >
                    Zonal Junior Boys Basketball Championship 2022-23
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_75.pdf?dfpew"
                    target="_blank"
                  >
                    Subroto Cup 2022-23 (Under 14 Boys)
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_76.pdf?MkLG4"
                    target="_blank"
                  >
                    South &amp; West India Taekwon-do Championship 2022
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_77.pdf?GWMqA"
                    target="_blank"
                  >
                    Zonal Senior Boys Football Championship 2022-23
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_78.pdf?zXESV"
                    target="_blank"
                  >
                    Zonal Volleyball Tournament 2022-23
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_79.pdf?eYSEZ"
                    target="_blank"
                  >
                    Zonal Athletics Meet 2022-23
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_80.pdf?Cvqhd"
                    target="_blank"
                  >
                    Subroto Cup 2022-23 (Under17 Boys): TAFS Vs. BANGLADESH
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_81.pdf?j8Aiv"
                    target="_blank"
                  >
                    Zonal Sub Junior Girls Badminton Championship 2022-23
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_82.pdf?17r0e"
                    target="_blank"
                  >
                    Delhi State Sub Junior Basketball Championship 2022-23
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_83.pdf?4J3V4"
                    target="_blank"
                  >
                    26th Fr. Peter Mermier Memorial Football Tournament 2022
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_84.pdf?jZuwQ"
                    target="_blank"
                  >
                    St. Francis De Sales Memorial Basketball Tournament 2022-23
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-0069062543.pdf"
                    target="_blank"
                  >
                    All India Karate Championship
                  </Link>
                </li>
              </ul>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_67.pdf?cNx4Q"
                    target="_blank"
                  >
                    {" "}
                    BASKETBALL
                  </Link>
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_68.pdf?EAY3g"
                    target="_blank"
                  >
                    {" "}
                    FOOTBALL
                  </Link>
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_69.pdf?PL8yq"
                    target="_blank"
                  >
                    {" "}
                    VOLLEYBALL
                  </Link>
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_70.pdf?4fGuD"
                    target="_blank"
                  >
                    {" "}
                    KHO KHO
                  </Link>
                </li>
              </ul>
              <p>
                <b>Activities Conducted In The School</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://www.tafssp.com/events?enc=MPjpqgYfGLeo3rLgVZH5W0JDcck0AIqnjYo9tTghYYtxnjZZjRrTwPpe71B2VQAh"
                    target="_blank"
                  >
                    {" "}
                    Adventure Activity - Sports Climbing
                  </Link>
                </li>
              </ul>
              <h6>2021-2022</h6>
              <p>
                <b>Activities Conducted In The School</b>
              </p>
              <ul className="list">
                <li>
                  <Link to="https://www.tafssp.com/events?enc=swJDWJPtHJ8jMn/vlDSaeZJfyBqPBHWXd6gP2yKDbXwi9bxRdA/gpewcB5HQojdrqroPTvrdMZarS3trRAbdgA==">
                    {" "}
                    INTERSECTION PUSH-UPS (BOYS) AND ROPE SKIPPING (GIRLS)
                    COMPETITION : CLASS VIII
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=swJDWJPtHJ8jMn/vlDSaeS/OdORtlJRlNDu67EjO6kN+UPi2pYXt1NKMZkhYA3nMFLHkDN0PPrO5LJ+ohTNmoQ==">
                    INTERSECTION YOGA COMPETITION (BOYS AND GIRLS) : CLASS VIII
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=swJDWJPtHJ8jMn/vlDSaeexyBVWe1UM4fJwtct23RHt0hs7vUaZbdiv8A6xumd0JrBUnBLEVUNY2+hRkX3RpBg==">
                    INTER SECTION YOGA COMPETITION (BOYS AND GIRLS) : CLASS VI
                  </Link>{" "}
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=swJDWJPtHJ8jMn/vlDSaeepqC5qXc01WSZsEKjeQ3hVGm01ofzBvg2wikKkv0aM03VlUwsYKGKSLqofDRn012w==">
                    TAFS VIRTUAL RUN WALK 2021
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=swJDWJPtHJ8jMn/vlDSaebcdHs/K2JmMh8gfHIYAKz+1nov8DQSLoiYhBZTmwJZsJHSCeu9/jgx6oeU8JucREQ==">
                    INTERSECTION PUSH-UPS (BOYS) AND ROPE SKIPPING (GIRLS)
                    COMPETITION : CLASS IX
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_66.pdf?Bi5iM"
                    target="_blank"
                  >
                    INTERSECTION PLANK COMPETITION (BOYS AND GIRLS) CLASSES VIII
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_71.pdf?yTOdT"
                    target="_blank"
                  >
                    TAFS SPORTS QUIZ 2.0
                  </Link>
                </li>
                <li>
                  <Link to="https://drive.google.com/file/d/1K88yMOWDql_lblnBF0HmMmf9wO8RNpML/view?usp=sharing">
                    SURYANAMASKAR
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=swJDWJPtHJ8jMn/vlDSaefdesgAXx8/8Dph5BKkRNffFjl/CCSajA2U6N7E6+MtrpVyNGKi9EsCOKwcqPU62Qg==">
                    <b>INTER HOUSE YOGA COMPETITION - CLASSES VI-VIII</b>
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=swJDWJPtHJ8jMn/vlDSaeYrZ5lxdvamSzKua+2TOiIGJTBVGgd2pKHjrZ4H7YcvQG3znr/mEAGZRRXdi7tDYzw==">
                    21 DAYS SURYA NAMASKAR PRACTICE PROGRAMME
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=K6G38CJ0P4/sKLqDU23ox7lBMrLlaN6o5yeX49rb9WRbNskHORZdB4Rd8UJ7Akw51orkxNLFfaBjs2QbDxJI9A==">
                    WEBINAR ON YOGA AND WELLBEING
                  </Link>
                </li>
              </ul>
              <p>
                <b>Achievement</b>
              </p>
              <ul className="list">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_72.pdf?JxVwP"
                    target="_blank"
                  >
                    {" "}
                    INTER SCHOOL SPORTS EVENTS 2021{" "}
                  </Link>{" "}
                </li>
              </ul>
              <h6>2020-2021</h6>
              <p>
                <b>Activities Conducted In The School</b>
              </p>
              <ul className="list">
                <li>
                  <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-0525740177.pdf">
                    Click Here To View - 3km Virtual Run (Fit India Freedom Run)
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=W1svHrXMa72TrEYjiSiL2p08Vj+mNF+DpmDg/nlLB6KZfKAlNF1rcYBFHfiy92Ina7+vH+d8/ftHGUtdme6Qhw==">
                    Click here to view - Fit India - October 2020
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=W1svHrXMa72TrEYjiSiL2kVTTlhbAoQhj5WlBbqchV9O0v6snhZgncC6pMMK4uIR9Yfzpw2wFxTMseiQgnVGnA==">
                    Click here to view - Fit India - November 2020
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=3XiFTpBGKxOd03+CUMK1b1JiHOm3xcqclWiFy7xWWJEnY3Dd2xcD2U7LP3k7Xlb+WsLedrEcmKXXfQjdQP2Clg==">
                    Click here to view - Inter House Fitness Week 2020
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_60.pdf?TCMIx"
                    target="_blank"
                  >
                    Click here to view - Result : Sports Awareness Quiz 2020
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_61.pdf?WDWsl"
                    target="_blank"
                  >
                    Click here to view - Result : Inter House Fitness Week - Senior
                    Category
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_62.pdf?L5AU0"
                    target="_blank"
                  >
                    Click here to view - Result : Inter House Fitness Week - Junior
                    Category
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_63.pdf?dtupy"
                    target="_blank"
                  >
                    Click here to view - Result : Inter House Fitness Week -
                    Sub-Junior Category
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=3XiFTpBGKxOd03+CUMK1b3b2p0KYdVWZmZaKIzfkjGJbIQnBae39Z8MAU65NMjF+LnII2+cNBdC60FIHzOoOuw==">
                    Click here to view - Inter-Section Yoga Competition
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_65.pdf?TQkkA"
                    target="_blank"
                  >
                    Click here to view - Result of Inter Section Yoga Competition
                  </Link>
                </li>
              </ul>
              <h6>2019-2020</h6>
              <p>
                <b>Activities Conducted In The School</b>
              </p>
              <ul className="list">
                <li>
                  <Link to="https://www.tafssp.com/events?enc=cGFnZT1ub25lJmlkPTkyMCZtb250aD1ub25lJmV0eXBlPTE=">
                    Click here to view - Run for Fun
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=cGFnZT1ub25lJmlkPTkyNCZtb250aD1ub25lJmV0eXBlPTE=">
                    Click here to view - TPL 2019
                  </Link>{" "}
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=cGFnZT1ub25lJmlkPTk4MyZtb250aD1ub25lJmV0eXBlPTE=">
                    Click here to view - Inter Section Kho-Kho (Girls)
                  </Link>{" "}
                </li>
              </ul>
              <p>
                <b>Sports News</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_59.pdf?Pp7Qn"
                    target="_blank"
                  >
                    List of Players - 11th All India Air Force Schools Athletics &
                    Sports Championship-2019
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_58.pdf?ZqPMg"
                    target="_blank"
                  >
                    List of Selected Players -Subroto Cup
                  </Link>
                </li>
              </ul>
              <p>
                <b>Achievement</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_57.pdf?zJGay"
                    target="_blank"
                  >
                    Delhi State Basketball Tournament – 2019 (Sub-Junior Boys)
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-0914633664.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Boys Tennis Championship 2019-20
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-1708501322.pdf"
                    target="_blank"
                  >
                    Zonal Taekwondo Championship 2019-20{" "}
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-1125413261.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Boys Basketball Championship 2019-20
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-1462603286.pdf"
                    target="_blank"
                  >
                    National Sports Achievers - Basketball
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-0729596954.pdf"
                    target="_blank"
                  >
                    Zonal Senior Boys Basketball Championship 2019-2020
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-1418158870.pdf"
                    target="_blank"
                  >
                    3rd Fr. Thomas Thoomkuzy Memorial Basketball Tournament 2019-20
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-1336192858.pdf"
                    target="_blank"
                  >
                    CBSE Taekwondo Championship 2019-20
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-1373714454.pdf"
                    target="_blank"
                  >
                    CBSE Basketball Championship 2019-20
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-1748426075.pdf"
                    target="_blank"
                  >
                    CBSE Cluster XX Delhi Region Athletics Championship 2019-20{" "}
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-0327025940.pdf"
                    target="_blank"
                  >
                    11th All India Air Force Schools Athletics & Sports
                    Championship-2019
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-0013175645.pdf"
                    target="_blank"
                  >
                    Zonal Junior Boys Volleyball Championship 2019-2020
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-1240381206.pdf"
                    target="_blank"
                  >
                    Zonal Athletics Championship 2019-20
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/bny-wcp-2407231216-1390299477.pdf"
                    target="_blank"
                  >
                    K.G Khosla Memorial Inter School Basketball Championship 2019-20
                  </Link>
                </li>
              </ul>
              <h6>2018-2019</h6>
              <p>
                <b>Activities Conducted In The School</b>
              </p>
              <ul className="list">
                <li>
                  <Link to="https://www.tafssp.com/events?enc=cGFnZT1ub25lJmlkPTcxMCZtb250aD1ub25lJmV0eXBlPTE=">
                    {" "}
                    Click here to view - Run for Fun Week
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=cGFnZT1ub25lJmlkPTc0MSZtb250aD1ub25lJmV0eXBlPTE=">
                    {" "}
                    Click here to view - Students Vs Teachers Cricket Match
                  </Link>
                </li>
                <li>
                  <Link to="https://www.tafssp.com/events?enc=cGFnZT1ub25lJmlkPTc1OCZtb250aD1ub25lJmV0eXBlPTE=">
                    {" "}
                    Click here to view - Cricket Match for Class XII
                  </Link>{" "}
                </li>
              </ul>
              <p>
                <b>Sports News</b>
              </p>
              <p>
                <b>INTER HOUSE BASKET BALL TOURNAMENT</b>{" "}
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_35.pdf"
                    target="_blank"
                  >
                    {" "}
                    INSTRUCTIONS
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_34.pdf"
                    target="_blank"
                  >
                    {" "}
                    FIXTURE
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_36.pdf"
                    target="_blank"
                  >
                    {" "}
                    LIST OF SELECTED PLAYERS - JUNIOR BOYS (IX)
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_38.pdf"
                    target="_blank"
                  >
                    {" "}
                    FIXTURE - JUNIOR BOYS (VIII)
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_39.pdf"
                    target="_blank"
                  >
                    {" "}
                    FIXTURE - JUNIOR GIRLS (VIII)
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_40.pdf"
                    target="_blank"
                  >
                    {" "}
                    LIST OF SELECTED PLAYERS -VIII
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_41.pdf"
                    target="_blank"
                  >
                    {" "}
                    FIXTURE - SUB JUNIOR BOYS (VII)
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_42.pdf"
                    target="_blank"
                  >
                    {" "}
                    FIXTURE - SUB JUNIOR GIRLS (VII)
                  </Link>
                </li>
                <li>
                  {" "}
                  <b>RESULTS</b>
                  <ul className="list">
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_37.pdf"
                        target="_blank"
                      >
                        25 APR 18
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_43.pdf"
                        target="_blank"
                      >
                        27 APR 18
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_44.pdf"
                        target="_blank"
                      >
                        02 MAY 18
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_45.pdf"
                        target="_blank"
                      >
                        04 MAY 18
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_46.pdf"
                        target="_blank"
                      >
                        08 MAY 18
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <p>
                <b>INTER HOUSE CRICKET TOURNAMENT (TPL)</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_19.pdf"
                    target="_blank"
                  >
                    {" "}
                    INSTRUCTIONS
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_20.pdf"
                    target="_blank"
                  >
                    {" "}
                    FIXTURE
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_27.pdf"
                    target="_blank"
                  >
                    {" "}
                    LIST OF SELECTED PLAYERS - JUNIOR BOYS (VIII-IX)
                  </Link>
                </li>
                <li>
                  {" "}
                  <b>RESULTS</b>
                  <ul className="list">
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_22.pdf"
                        target="_blank"
                      >
                        10 APR 2018
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_26.pdf"
                        target="_blank"
                      >
                        11 APR 2018
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_28.pdf"
                        target="_blank"
                      >
                        13 APR 2018
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_29.pdf"
                        target="_blank"
                      >
                        16 APR 2018
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_30.pdf"
                        target="_blank"
                      >
                        17 APR 2018
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_31.pdf"
                        target="_blank"
                      >
                        18 APR 2018
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_32.pdf"
                        target="_blank"
                      >
                        20 APR 2018
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_33.pdf"
                        target="_blank"
                      >
                        23 APR 2018
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <p>
                <b>Result</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_47.pdf"
                    target="_blank"
                  >
                    Zonal Taekwondo Championship 2018-19
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_48.pdf"
                    target="_blank"
                  >
                    Zonals Senior Girls Tennis Championship 2018-19
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_49.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Girls Basketball Championship 2018-19
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_50.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Boys Basketball Championship 2018-19
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_51.pdf"
                    target="_blank"
                  >
                    2nd Fr. Thomas Thoomkuzy Memorial Tournament 2018-19
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_52.pdf"
                    target="_blank"
                  >
                    Tenth All India Air Force Schools Athletics & Sports
                    Championship 2018
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_53.pdf"
                    target="_blank"
                  >
                    Zonal Athletics Championship 2018-19
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_54.pdf"
                    target="_blank"
                  >
                    CBSE Cluster XX Delhi Region Athletics Championship 2018-19
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_56.pdf"
                    target="_blank"
                  >
                    CBSE Taekwondo Championship 2018-19
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_55.pdf"
                    target="_blank"
                  >
                    Zonal Athletics (Throwing Events) Championship 2018-19
                  </Link>
                </li>
              </ul>
              <h6>2017-2018</h6>

              <p>
                <b>Activities Conducted In The School</b>
              </p>
              <ul className="list">
                <li>
                  Click here to view -{" "}
                  <Link to="https://www.tafssp.com/events?enc=dHlwZT1ldmVudCZpZD01ODMmbW9udGg9bm9uZSZmb3JtaWQ9MTAwMDEmZXR5cGU9MQ==">
                    Run for Fun Week
                  </Link>
                </li>
                <li>
                  Click here to view -{" "}
                  <Link to="https://www.tafssp.com/events?enc=cGFnZT1ub25lJmlkPTY5MCZtb250aD1ub25lJmV0eXBlPTE=">
                    Sports for Teachers
                  </Link>
                </li>
                <li>
                  Click here to view -{" "}
                  <Link to="/pdfcontentpage_105_139_18.pdf" target="_blank">
                    Sports for Teachers held on 24 March 2018
                  </Link>
                </li>
              </ul>
              <p>
                <b>Sports News</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_1.pdf"
                    target="_blank"
                  >
                    Dated : 22 Aug 2017
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_2.pdf"
                    target="_blank"
                  >
                    Dated : 23 Aug 2017
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_3.pdf"
                    target="_blank"
                  >
                    Dated : 24 Aug 2017
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_5.pdf"
                    target="_blank"
                  >
                    Dated : 25 Aug 2017
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_6.pdf"
                    target="_blank"
                  >
                    Dated : 26 Aug 2017
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_7.pdf"
                    target="_blank"
                  >
                    Dated : 28 Aug 2017
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_10.pdf"
                    target="_blank"
                  >
                    Dated : 01 Sep 2017
                  </Link>
                </li>
              </ul>
              <p>
                <b>Result</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_4.pdf"
                    target="_blank"
                  >
                    Zonal Senior Boys Basketball Championship 2017-18
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_8.pdf"
                    target="_blank"
                  >
                    1st Fr. Thomas Thoomkuzy Memorial Tournament 2017-18
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_9.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Girls Badminton Championship 2017-18
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_11.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Boys Basketball Championship 2017-18
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_13.pdf"
                    target="_blank"
                  >
                    Ninth All India Air Force Schools Athletics & Sports
                    Championship 2017
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_14.pdf"
                    target="_blank"
                  >
                    CBSE Cluster XX Delhi Region Athletics Championship 2017-18
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_15.pdf"
                    target="_blank"
                  >
                    23rd North Zone Sports Climbing Championship – 2017
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Sports-Activities/contentpage_105_139_16.pdf"
                    target="_blank"
                  >
                    Zonal Senior Girls Tennis Championship 2017-18
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SportsActivitiesData;
